<template>
  <div class="position-relative z-50">
    <div v-if="isShowIntro2" class="review-flashing">
      <FlashingButton
        :contents="contents2"
        title="Schedule Interview"
        content-class="rejected-position rejected-position-right"
        bottom
        rightClass="approve-hotspot"
        :showFakeCard="showFakeCard"
        @close="$emit('closeInfo')"
      />
    </div>
    <v-menu
      v-model="openPopup"
      top
      offset-y
      left
      nudge-bottom="50"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <Button :loading="loading">
                  <div
                    class="tw-flex tw-gap-3 tw-text-base tw-items-center tw-justify-center tw-text-sm tw-min-w-[210px]"
                  >
                    <div>
                      <img :src="LikeIcon" />
                    </div>
                    <div>Schedule interview</div>
                  </div>
                </Button>
              </div>
            </template>
            <div class="tw-w-[275px] tw-text-white tw-py-2">
              <Typography variant="body-2">
                Click on “Schedule Interview” to move forward with this
                candidate for a first interview. Upon clicking this button,
                Hirefly will send an instant intro email to you and the
                candidate and prompt the candidate to schedule time with you.
              </Typography>
            </div>
          </v-tooltip>
        </div>
      </template>
      <div class="accept-satisfaction">
        <h2 class="text-center max-w-257 mx-auto">
          Hirefly will notify the candidate to schedule the interview.
        </h2>
        <p class="text-xs mt-4 text-center mb-0 sub-title">
          (For Hirefly use only * Mandatory)
        </p>
        <h3 class="mt-2">How would you rate this candidate?*</h3>
        <div class="">
          <div class="mt-4 radio-list">
            <v-radio-group v-model="rate" hide-details>
              <v-radio
                v-for="(n, i) in ['Satisfactory', 'Good', 'Excellent']"
                :key="n"
                :label="n"
                :value="i + 1"
              ></v-radio>
            </v-radio-group>
          </div>
          <h3 class="mt-5">Select all that you liked in this candidate*</h3>
          <div class="match-skills">
            <v-chip
              v-for="(item, ind) in matchSkills"
              :key="ind"
              :class="{ active: selectedSkills.includes(item) }"
              @click="addMatchSkills(item)"
            >
              {{ item }}
            </v-chip>
          </div>
          <h3 class="mt-5">Any other feedback?</h3>
          <v-textarea
            v-model="approval_score_other"
            :rows="1"
            :auto-grow="true"
            hide-details
          >
          </v-textarea>
        </div>
        <div class="d-flex justify-center pt-6">
          <v-btn color="primary" :disabled="!isValid" @click="submitHandler">
            Schedule Interview
          </v-btn>
        </div>
      </div>
    </v-menu>
  </div>
</template>
<script>
import Button from '@/components/v3/base/Button';
import LikeIcon from '@/assets/icons/thumbs-up.svg';
import Typography from '@/components/v3/base/Typography';
import FlashingButton from '../information-tours/FlashingButton';

export default {
  name: 'AcceptSatisfaction',
  components: {
    Typography,
    FlashingButton,
    Button,
  },

  props: {
    disabled: Boolean,
    isFront: Boolean,
    iscurrentGolive: Boolean,
    isShowIntro2: Boolean,
    introStep: [Number, String],
    showFakeCard: Boolean,
    loading: Boolean,
  },

  data() {
    return {
      rate: null,
      approval_score_other: '',
      openPopup: false,
      showHotSpot: true,
      contents: [
        'Click on “Schedule Interview” to move forward with this candidate for a first interview. Upon clicking this button, Hirefly will send an instant intro email to you and the candidate and prompt the candidate to schedule time with you.',
      ],

      contents2: [
        'Click on “Schedule Interview” to move forward with this candidate for a first interview. Upon clicking this button, Hirefly will send an instant intro email to you and the candidate and prompt the candidate to schedule time with you.',
      ],

      matchSkills: [
        'Skills match',
        'Companies worked at',
        'Education',
        'Industry worked at',
        'Professional background',
        'Relevant Experience',
      ],

      selectedSkills: [],
      LikeIcon,
    };
  },

  computed: {
    isValid() {
      return this.selectedSkills.length && this.rate;
    },
  },

  methods: {
    submitHandler() {
      this.openPopup = false;
      const approvalScoreOther = this.selectedSkills;
      if (this.approval_score_other) {
        approvalScoreOther.push(this.approval_score_other);
      }
      const payload = {
        approval_score: this.rate,
        approval_score_other: approvalScoreOther.join(', '),
      };
      this.$emit('submit', payload);
    },

    closeHandler() {
      this.showHotSpot = false;
      this.$emit('close');
    },

    addMatchSkills(item) {
      const ind = this.selectedSkills.indexOf(item);
      if (ind === -1) {
        this.selectedSkills.push(item);
      } else {
        this.selectedSkills.splice(ind, 1);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.v-menu__content {
  border-radius: 20px;
}
.accept-satisfaction {
  background-color: #fff;
  width: 370px;
  padding: 24px;
  font-size: 14px;
  color: #111827;
  .text-xs {
    font-size: 12px;
  }
  h2 {
    font-size: 14px;
    font-weight: 500;
  }
  h3 {
    font-size: 14px;
    font-weight: 600;
  }
  .max-w-257 {
    max-width: 257px;
    margin-left: auto;
    margin-right: auto;
  }
}
.sub-title {
  color: #6b7280;
  font-size: 12px;
}
.radio-list {
  padding-left: 24px;
  &::v-deep {
    .v-label {
      font-size: 12px;
    }
  }
}
.match-skills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  border: 1px solid #e6e7eb;
  padding: 12px;
  &::v-deep .v-chip {
    font-size: 10px;
    height: 22px;
    background: #fff !important;
    border: 1px solid #e6e7eb;
    &.active {
      background: #e0e0e0 !important;
    }
  }
}
::v-deep {
  .v-slider--horizontal .v-slider__track-container {
    height: 8px;
    border-radius: 8px;
    overflow: hidden;
  }
  .v-slider--horizontal .v-slider__ticks-container {
    height: 8px;
  }
  .v-slider__tick-label {
    font-size: 10px;
    margin-top: 16px;
    font-weight: 500;
  }
  .v-text-field__slot {
    border: 1px solid #d8d8d8;
    padding: 8px;
    textarea {
      font-size: 14px;
    }
  }
  .v-btn__content {
    text-transform: none;
  }
  .v-slider__thumb {
    width: 30px;
    height: 30px;
    left: -15px;
    background-color: #fff !important;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }
  .v-slider__thumb:before {
    content: '';
    left: -3px;
    top: -3px;
    display: none;
  }
}
.card-footer-btn {
  height: 43px !important;
  .card-footer-btn-text {
    font-weight: normal;
    text-transform: capitalize;
    line-height: normal;
    letter-spacing: 0.54px;
    color: #111827;
  }
}
.review-flashing {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, 0);
}
.z-50 {
  z-index: 50;
}
.z-1 {
  z-index: 1;
}
.overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  z-index: 2;
}
</style>
